module.exports = __webpack_public_path__ + "img/lock.e024eb22.svg";